// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3JaSq","dragIcon":"Choice_dragIcon__3oMKy","left":"Choice_left__35ByM","input":"Choice_input__1yWMO"};